import React, { useEffect, useState } from "react";
import "./ViewCoapplicant.css";
import { AiOutlineTable } from "react-icons/ai";
import { TextField } from "@mui/material";
import { MenuItem } from "@mui/material";
// import { Button } from "@mui/material";
import {
  // AiOutlineFileExcel,
  // AiOutlineFilePdf,
  // AiFillFile,
} from "react-icons/ai";
import { BsPencilSquare } from "react-icons/bs";
// import { RiDeleteBinLine } from "react-icons/ri";
// import { jsonData } from "../AddCoApplicant/coapp-test";
import Sidebar from "../../../Sidebar/Sidebar";
// import * as XLSX from "xlsx";
// import ReactPaginate from "react-paginate";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import {url} from '../../../App'
import Cookies from 'js-cookie';

const ViewCoApplicant = () => {

  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [coapplicants, setCoapplicants] = useState([]);
  const token = Cookies.get('Token');
  const [rowNumber, setRowNumber] = useState(10);
  var [pageCount, setPageCount] = useState(1);
  const email = Cookies.get('Email');
  const [query, setQuery] = useState("");
  // const [coApp, setCoApp] = useState("name");
  // const coAppSearchHandler = (e) => setCoApp(e.target.value);
  const [isOpen, setIsOpen] = useState(true);
  const openView = (val) => setIsOpen(val);
  const [visible, setvisible] = useState(false);
  const [EditCoapplicantVisible, setEditCoapplicantVisible] = useState(false);
  // const [sheetData, setSheetData] = useState(null);

  useEffect(() => {
   
      if (email === "rupesh.bishnoi@credin.in") {
        setvisible(true);
      } else{
      axios
      .post(url + "/user/getsingle", {
        token: token,
        email: email,
        useremail:email
      })
      .then((res) => {
        // console.log(res);
        setEditCoapplicantVisible(res.data[0].permission.edit_co_borrower);
      })
      .catch((err) => {
        // console.log(err);
      })};
  
      setOpen(true)
      axios
        .post(url + "/coapplicant/getall", {
          token: token,
          email: email,
          pageSize: rowNumber,
          page: pageCount
        })
        .then((res) => {
           console.log(res)
          if(res.data.logout===true){
            setOpen(false)
            setTimeout(() => {
              toast.error(res.data.message);
            navigate("/");
            }, 3000);
          }
          else if (res.data.auth === false) {
            setOpen(false)
            // toast.error(res.data.message);         
          } else {
            setOpen(false)
            if(res.data.message.length === 0 && pageCount>1) return setPageCount((pageCount)=>pageCount-1);
            setCoapplicants(res.data.message);
          }
        })
        .catch((err) => {
          setOpen(false)
          // console.log(err);
        });
    }, [token,email,rowNumber,pageCount,navigate]);

  // const handleDeleteCoapplicant = (coapplicant_id) => {
  //   let text = "Are you sure you want to delete " + coapplicant_id + "?";
  //   if (window.confirm(text) === true) {
  //     axios
  //       .post(url+"/coapplicant/delete", {
  //         token: token,
  //         email: email,
  //         coapplicant_id: coapplicant_id,
  //       })
  //       .then((res) => {
  //         // // console.log(res);
  //         toast.success(res.data.message);
  //         axios
  //           .post(url+"/coapplicant/getall", {
  //             token: token,
  //             email: email,
  //           })
  //           .then((res) => {
  //             // // console.log(res.data);
  //             toast.dismiss("custom");
  //             toast.success("Coapplicants Fetched Successfully");
  //             setCoapplicants(res.data.reverse());
  //           })
  //           .catch((err) => {
  //             // console.log(err);
  //             toast.dismiss("custom");
  //             toast.error(err.message);
  //           });
  //       })
  //       .catch((err) => {
  //         // console.log(err);
  //         toast.error(err);
  //       });

  //     toast.info("Fetching Details...", {
  //       autoClose: false,
  //       toastId: "custom",
  //     });
  //   }
  // };

  // const handleVerifyCoapplicant = (coapplicant_id) => {
  //   let text = "Are you sure you want to Verify " + coapplicant_id + "?";
  //   if (window.confirm(text) === true) {
  //     axios
  //       .post(url+"/coapplicant/verified", {
  //         token: token,
  //         email: email,
  //         coapplicant_id: coapplicant_id,
  //       })
  //       .then((res) => {
  //         // // console.log(res);
  //         if(res.data.auth === true){
  //           toast.success(res.data.message);
  //         }
  //         else{
  //           toast.error(res.data.message);
  //         }
  //         axios
  //           .post(url+"/coapplicant/getall", {
  //             token: token,
  //             email: email,
  //           })
  //           .then((res) => {
  //             // // console.log(res.data);
  //             toast.dismiss("custom");
  //             toast.success("Coapplicants Fetched Successfully");
  //             setCoapplicants(res.data.reverse());
  //           })
  //           .catch((err) => {
  //             // console.log(err);
  //             toast.dismiss("custom");
  //             toast.error(err.message);
  //           });
  //       })
  //       .catch((err) => {
  //         // console.log(err);
  //         toast.error(err);
  //       });

  //     toast.info("Fetching Details...", {
  //       autoClose: false,
  //       toastId: "custom",
  //     });
  //   }
  // };

  // const handleExcelExport = () => {
  //   let wb = XLSX.utils.book_new();
  //   let ws = XLSX.utils.json_to_sheet(sheetData);

  //   ws["!cols"] = [
  //     { width: 20, alignment: { horizontal: "center", vertical: "middle" } },
  //     { width: 20 },
  //     { width: 20 },
  //     { width: 20 },
  //     { width: 20 },
  //     { width: 20 },
  //     { width: 20 },
  //   ];
  //   ws["!rows"] = [{ hpt: 25 }];

  //   XLSX.utils.book_append_sheet(wb, ws, "CoAppSheet");

  //   XLSX.writeFile(wb, "Co-Applicants.xlsx");
  // };


  const paginationViewHandler = (e) => {
    parseInt(setRowNumber(e.target.value));
  };

  // const [currentPage, setCurrentPage] = useState(0);

  // const handlePageChange = ({ selected }) => {
  //   setCurrentPage(selected);
  // };
  // const itemsPerPage = rowNumber;

  // const pageCount = Math.ceil(coapplicants.length / itemsPerPage);

  // const getItemsForPage = (items, page) => {
  //   const startIndex = page * itemsPerPage;
  //   const endIndex = startIndex + itemsPerPage;
  //   return items.slice(startIndex, endIndex);
  // };

  const abc = (coapplicantBirthday) => {
    let newDate = new Date(coapplicantBirthday);
    return (`${newDate.getDate() < 10 ? "0"+(newDate.getDate()):newDate.getDate()}-${newDate.getMonth() + 1 < 10 ? "0"+(newDate.getMonth() + 1) : (newDate.getMonth() + 1)}-${newDate.getFullYear()}`);
  }

  const getPageLoad = (e) => {
    // setOpen(true);
    if(e === "inc"){
      setPageCount((pageCount)=>pageCount+1);
    }else{
      setPageCount((pageCount)=>pageCount-1);
    }
  }

  const serachDateApi = () =>{
    setOpen(true)
    axios
      .post(url + "/coapplicant/search", {
        token: token,
        email: email,
        borrowerUniqueNo: query
      })
      .then((res) => {
        if (res.data.auth === false) {
          setOpen(false)
          setTimeout(() => {
            window.location.reload();
          }, 3000);
          toast.error(res.data.message);
        } else {
          setOpen(false)
          if(res.data.message.length === 0) return setCoapplicants([])
          setCoapplicants(res.data.message);
          // console.log(res.data);
        }
      })
      .catch((err) => {
        setOpen(false)
        // console.log(err);
        toast.error(err.message);
      });
  }

  return (
    <>
      <div style={{ height: "20px" }} />
      <Sidebar click={openView} dataSend={"ViewCoApplicant"} />
      <div style={{ marginLeft: isOpen ? "15%" : "0", transition: "all 0.2s" }}>
        <div className="main-container">
          <div className="content-container">
            <h3 className="main-heading">
              <AiOutlineTable />
              View Co-Applicant
            </h3>
            <div className="table-coapplicant-input-fields">
              {/* <div className="table-head-inputs">
                <label>Select Data</label>
                <TextField
                  className="input-field"
                  placeholder="Select Data..."
                  select
                  name="created-data"
                  variant="outlined"
                  value={coApp}
                  size="small"
                  onChange={coAppSearchHandler}
                >
                  <MenuItem value="name">Name</MenuItem>
                  <MenuItem value="mob">Phone Number</MenuItem>
                  <MenuItem value="uniqueno">Unique Number</MenuItem>
                  <MenuItem value="email">E-Mail</MenuItem>
                </TextField>
              </div> */}
              <div className="table-head-inputs">
                {/* <label>Search Data</label> */}
                <TextField
                  placeholder="Coapp Id / Coapp Mobile / Unique No / Loan Id"
                  name="search-data"
                  id="search-data"
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  variant="outlined"
                  size="small"
                  sx={{ width: "45ch"}}
                />
              </div>
              <button className="digi-kyc" onClick={serachDateApi}>Search</button>

              {/* <div className="heading-dl-btns">
                <Button>
                  <AiOutlineFileExcel
                    className="xl-btn"
                    // onClick={handleExcelExport}
                  />
                </Button>
                <Button>
                  <AiOutlineFilePdf className="pdf-btn" />
                </Button>
              </div> */}
            </div>
            <div className="lms-table-div">
              <table className="lms-table">
                <thead>
                  <tr>
                    <th>Coapplicant Name</th>
                    <th>Mobile No.</th>
                    {/* <th>E-Mail Address</th> */}
                    <th>Date of Birth</th>
                    <th>Borrower Name</th>
                    <th>Branch Name</th>
                    <th>Coapplicant Id</th>
                    {/* <th>Unique No.</th> */}
                    <th>Loan Id</th>
                    <th>Status</th>
                    {(EditCoapplicantVisible || visible) && (
                    <th>Action</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {/* {getItemsForPage(jsonData, currentPage).map((coapp) => (
                    <tr key={coapp.id}>
                      <td>{coapp.name}</td>
                      <td>{coapp.mob}</td>
                      <td>{coapp.email}</td>
                      <td>{coapp.primeborrower}</td>
                      <td>{coapp.uniqueno}</td>
                      <td>{coapp.loan}</td> */}
                  {/* {getItemsForPage(coapplicants, currentPage)
                    ?.filter((user) =>
                      user.coapplicant_id?.toLowerCase().includes(query)
                    ) */}
                    {coapplicants.length > 0 &&
                    coapplicants?.map((coapplicant, index) => {
                      return (
                        <tr key={index}>
                          <td style={{wordWrap:"break-word",maxWidth:"150px"}}>{coapplicant.coapplicant_name}</td>
                          <td>{coapplicant.coapplicant_mobile}</td>
                          {/* <td>{coapplicant.coapplicant_email}</td> */}
                          <td>{abc(coapplicant.coapplicant_dob)}</td>
                          <td className="hover-td"
                          onClick={() => {
                                navigate(`/borrower/detail/${coapplicant.coapplicant_loan_id}`);
                                localStorage.setItem(
                                  "uniqueID",
                                  coapplicant.coapplicant_borrower_uniqueno
                                )
                              }}
                              >{coapplicant.coapplicant_borrower_name}</td>
                               <td>{coapplicant.coapplicant_branchname}</td>
                          <td>{coapplicant.coapplicant_id}</td>
                          {/* <td>{coapplicant.coapplicant_borrower_uniqueno}</td> */}
                          <td>{coapplicant.coapplicant_loan_id}</td>
                          <td>{coapplicant.coapplicant_status?"Verified":"Not Verified"}</td>
                          {(EditCoapplicantVisible || visible) && (
                          <td className="table-btn-col">
                            {/* <button className="table-icon-btn">
                              <AiFillFile />
                            </button> */}
                             {(EditCoapplicantVisible || visible) && (
                            <Link to="/coapplicant/edit" state={coapplicant}>
                              <button className="table-icon-btn" title="Edit">
                                <BsPencilSquare />
                              </button>
                            </Link>
                             )}
                            {/* <button
                              className="table-icon-btn"
                              style={{ color: "red" }}
                              title="Delete"
                              onClick={() =>
                                handleDeleteCoapplicant(
                                  coapplicant.coapplicant_id
                                )
                              }
                            >
                              <RiDeleteBinLine />
                            </button> */}
                            {/* <button className="table-cust-btn" onClick={() => handleVerifyCoapplicant(coapplicant.coapplicant_id)}>Verify</button> */}
                          </td>
                          )}
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
            <div className="pagination-div">
              <div className="pagination-select">
                <label>Entries To Display</label>
                <TextField
                  className=""
                  placeholder="rows"
                  select
                  name="created-data"
                  variant="outlined"
                  value={rowNumber}
                  size="small"
                  onChange={paginationViewHandler}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </TextField>
              </div> 
              <div className="pagination-bar">
              <button className="digi-kyc" style={{marginLeft:"1rem"}} onClick={() => getPageLoad("dec")} disabled={pageCount === 1}>Previous</button>
              </div>
              <span className="pageCount" style={{ margin: "1rem" }}>{ pageCount }</span>
              <div className="pagination-bar">
                <button className="digi-kyc" onClick={() => getPageLoad("inc")}>Next</button>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      </div>
    </>
  );
};

export default ViewCoApplicant;
